export const useCurrentSubscription: () => { tools: string[] } | null = () => {
  const { getCurrentSubscription } = useSubscriptionAuth();
  return getCurrentSubscription();
};
